import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-alberiq',
  templateUrl: './alberiq.component.html',
  styleUrls: ['./alberiq.component.css']
})
export class AlberIQComponent implements OnInit, OnDestroy {

  subscriptions: Subscription = new Subscription();

  baseUrl: string = '';
  
  constructor(
    //private userService: UserService,
    private router: Router) {
    this.baseUrl = location.origin; 
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
